import React from "react";
import { PieChart, Pie, Cell as PieCell, Tooltip, Legend, ResponsiveContainer, Sector } from "recharts";
import { useEffect, useState } from "react";
import * as api from '../../api/index.js';

export default function TrailAnalytics() {
    const [trails, setTrails] = useState([]);
    const [activeIndex, setActiveIndex] = useState(null);


    useEffect(() => {
        const fetchTrails = async () => {
            try {
                const { data } = await api.fetchTrails();
                setTrails(data);
            } catch (error) {
                console.error('Error fetching trails:', error);
            }
        };

        fetchTrails();
    }, []);

    const data = {
        nodes: trails.map(trail => ({
            id: trail._id,
            name: trail.name,
            value: trail.usages, // usages determine the pie chart slices
        }))
    };

    //const columns = [
     //   { label: "Name", accessor: "name" },
     //   { label: "Value", accessor: "value" },
    //];

    const COLORS = ["#eda60aff", "#a5acb0", "#00704a"];

      // darken color for active slice
  const darkenColor = (color, amount = 0.2) => {
    let c = color.replace("#", "");
    if (c.length === 8) c = c.slice(0, 6);
    const num = parseInt(c, 16);
    let r = (num >> 16) & 0xff;
    let g = (num >> 8) & 0xff;
    let b = num & 0xff;

    r = Math.max(0, Math.min(255, r * (1 - amount)));
    g = Math.max(0, Math.min(255, g * (1 - amount)));
    b = Math.max(0, Math.min(255, b * (1 - amount)));

    return `rgb(${Math.round(r)}, ${Math.round(g)}, ${Math.round(b)})`;
  };

    const handlePieClick = (_, index) => {
    setActiveIndex(prev => (prev === index ? null : index));
  };

      // Renders the same slice but with a stroked outline to indicate active
  const renderActiveShape = (props) => {
    const {
      cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill
    } = props;

    // Draw the normal filled sector (so it looks identical) and then an outer stroked
    // sector slightly bigger to act as the outline
    return (
      <g>
        {/* Normal slice (keeps the look identical) */}
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
        />
        {/* Outline sector slightly larger (acts as the black highlight) */}
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={outerRadius + 1}            // a thin ring outside the slice
          outerRadius={outerRadius + 6}            // width of ring (adjustable)
          startAngle={startAngle}
          endAngle={endAngle}
          fill="none"
          stroke="#000"                            // black outline
          strokeWidth={3}
        />
      </g>
    );
  };

  // Optional: change active on hover for desktop (uncomment if wanted)
  // const handlePieEnter = (_, index) => setActiveIndex(index);

    return (
        <div className="container text-center mt-4" style={{ paddingBottom: "1rem" }}>
            <h1 className="mb-4">Trail Usage Distribution</h1>

            <div className="chart-container">
                <ResponsiveContainer width="100%" height={400}>
  <PieChart>

    <Pie
      data={data.nodes}
      dataKey="value"
      nameKey="name"
      cx="50%"
      cy="45%"
      outerRadius={"90%"}
      label={false}
    activeIndex={activeIndex}     // ← disables highlighting
    activeShape={null}     // ← disables outline + box
    isAnimationActive={false} // ← prevents reset effects
  onClick={handlePieClick}     // toggle active slice
    >
  {data.nodes.map((entry, index) => {
    const baseColor = COLORS[index % COLORS.length];
    const fillColor = index === activeIndex ? darkenColor(baseColor, 0.25) : baseColor;
    return <PieCell key={entry.id || index} fill={fillColor} />;
  })}
    </Pie>


    <Tooltip
  trigger="click"
  formatter={(value, name) => [`${value} uses`, name]}
  contentStyle={{
    background: "#fff",
    border: "1px solid #ccc",
    color: "#000"
  }}
/>


<Legend
  layout="vertical"
  verticalAlign="bottom"
  align="center"
    wrapperStyle={{
    marginTop: 20,
    padding: 10,
    backgroundColor: '#4b4b4bff', // dark gray background
    borderRadius: 8,
    display: 'inline-block'
  }}
  formatter={(value, entry) => {
    const total = data.nodes.reduce((sum, n) => sum + n.value, 0);
    const pct = ((entry.payload.value / total) * 100).toFixed(1);

    return (
      <span className="legend-text" style={{ color: "#ffffffff"}}>
        {value}: {pct}%
      </span>
    );
  }}
/>

  </PieChart>
</ResponsiveContainer>
</div>
            
    </div>
);
}
